import { ENVIRONMENT_INITIALIZER, makeEnvironmentProviders } from '@angular/core';
import { RecentlyViewedEngine } from '@df/catalog-ui/recently-viewed/recently-viewed-engine';
import { CategoryEngine } from '@df/catalog-ui/related-products/category-engine';
import { RelatedEngine } from '@df/catalog-ui/related-products/related-engine';
import { UpsellEngine } from '@df/catalog-ui/related-products/upsell-engine';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';
import { KlevuContextRecommendationsModelCarouselEngine } from '../../../module/klevu-search/klevu-context-recommendations-model-carousel-engine';
import { ModelCarouselAttributeEngine } from '../../page/component/model-carousel/model-carousel-attribute-engine';

const engines = [
    CategoryEngine,
    RelatedEngine,
    RecentlyViewedEngine,
    KlevuContextRecommendationsModelCarouselEngine,
    UpsellEngine,
    ModelCarouselAttributeEngine
];
export const provideRelatedProductsEngines = () => {
    return makeEnvironmentProviders([
        {
            provide: ENVIRONMENT_INITIALIZER,
            useFactory: () => () => {
                return surviveTreeShaking(engines);
            },
            multi: true
        }
    ]);
};